package com.crowpay.views.dialogs

import com.crowpay.*
import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.utils.resize
import com.crowpay.views.theming.ImagePreviewSemantic
import com.lightningkite.kiteui.Platform
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.screenNavigator
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.usesTouchscreen
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.Recycler2
import com.lightningkite.kiteui.views.l2.RecyclerViewData
import com.lightningkite.kiteui.views.l2.RecyclerViewPagingPlacer
import com.lightningkite.kiteui.views.l2.RecyclerViewRendererSet
import com.lightningkite.kiteui.views.l2.icon


class ImagePreview(val images: List<Attachment>) : Page {

    override fun ViewWriter.render2(): ViewModifiable {
        return dismissBackground {
            spacing = AppDimensions.fullIndent
            (ImagePreviewSemantic + DialogSemantic).onNext - gravity(Align.Stretch, Align.Center) - sizeConstraints(minHeight = 20.rem) - stack {
                expanding - Recycler2(this, false).apply {
                    placer = RecyclerViewPagingPlacer()
                    snapToElements = Align.Center
                    scrollSnapStop = true

                    data = RecyclerViewData.fromList(images)

                    rendererSet = RecyclerViewRendererSet.single<Attachment, String>({ it.file.location }) { attachment ->
                        zoomableImage {
                            scaleType = ImageScaleType.Fit
                            ::exists { attachment().fileType.startsWith("image") }
                            ::source {
                                attachment().let {
                                    if (it.fileType.startsWith("image")) it.file.location.let(::ImageRemote)
                                    else null
                                }
                            }
                        }
                        centered - externalLink {
                            ::exists { !attachment().fileType.startsWith("image") }
                            h3("Open File")
                            ::to { attachment().file.location }
                            newTab = true
                        }
                    }
                    with(outerStack) {
                        if(!Platform.usesTouchscreen) {
                            gravity(Align.Start, Align.Center) - card - button {
                                icon(Icon.chevronLeft, "Previous")
                                onClick { centerIndex set (centerIndex() - 1) % images.size }
                            }
                            gravity(Align.End, Align.Center) - card - button {
                                icon(Icon.chevronRight, "Next")
                                onClick { centerIndex set (centerIndex() + 1) % images.size }
                            }
                        }
                    }
                }
                atTopEnd - card - buttonTheme - button {
                    centered - icon(Icon.close.resize(2.rem), "Close Preview")
                    onClick {
                        screenNavigator.dismiss()
                    }
                }
            }

            onClick { screenNavigator.dismiss() }
        }
    }
}